import { cn } from "./cn";

/** Soft segmented look, shared with Tabs: sunken track, raised active pill. */
export const segmentedTrackClassName =
  "flex min-w-0 gap-0.5 overflow-x-auto rounded-lg bg-sunken p-0.5";

export const segmentedItemClassName = cn(
  "tap-target min-h-9 shrink-0 grow whitespace-nowrap rounded-[11px] px-3.5 text-footnote font-semibold text-fg-muted",
  "transition-[background-color,color,box-shadow] motion-fast",
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus",
);

export const segmentedActiveClassName = "bg-raised text-fg shadow-card";
